import React from "react";
import Navbar from "./components/Navbar";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import Careers from "./components/Careers";
function App() {
  return (
    <div>
      <div>
        <Navbar />
        {/* contact us start */}
        {/* <ContactUs></ContactUs> */}

        {/* contact us end */}
        {/* Careers start */}
        <Careers></Careers>
        {/* Careers end */}
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;
